import type { Nullable } from "models-webgl2";
import { addLineNumbersWithError } from "./add-line-numbers-with-error";
import { getWebglShaderType, WebglShadersType } from "./get-webgl-shader-type";

export const createShader = (
  gl: WebGL2RenderingContext,
  shaderSource: string,
  shaderType: WebglShadersType,
  opt_errorCallback?: (error: string) => void,
): Nullable<WebGLShader> => {
  const errFn = opt_errorCallback || console.error;

  // Create the shader object
  const shader = gl.createShader(getWebglShaderType(gl, shaderType));

  // Something went wrong during shader creation.
  if (!shader) {
    errFn("Error while creating shader");
    return null;
  }

  // Load the shader source
  gl.shaderSource(shader, shaderSource);

  // Compile the shader
  gl.compileShader(shader);

  // Check compile status
  const compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
  if (!compiled) {
    // Something went wrong during compilation, get the error
    const lastError = gl.getShaderInfoLog(shader) || "";

    errFn(
      `Error compiling shader: ${lastError}\n${addLineNumbersWithError(shaderSource, lastError)}`,
    );

    gl.deleteShader(shader);

    return null;
  }

  return shader;
};
